import { BulkUpdatePayeesRow } from '@willow/types-iso';

import { makeValidator } from '../shared/makeValidator';

export const validateBulkUpdatePayees = makeValidator({
  FieldParser: BulkUpdatePayeesRow,
});
